<template>
  <div class="d-block d-md-none">
    <div class="row">
      <div class="col-4 px-0">
        <button @click="goBack" class="btn border-0 bg-none">
          <i class="fas fa-chevron-left mr-2"></i>Back
        </button>
      </div>
      <div class="col-6 text-left px-0">
        <h3 class="text-bold">{{ title || 'Section' }}</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { goBackMixin } from '../utils/goBack.mixin';

export default {
  props: ['title'],
  mixins: [
    goBackMixin
  ]

}
</script>
